import React, { Component } from 'react';
import Optgroup from './Optgroup';
import Option from './Option';

class FilterSelect extends Component {

	constructor(props)
	{
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e)
	{
		this.props.onChange(e.target);
	}

	render()
	{
		var selectItems = this.props.options.map(function(option, i)
		{
			if (option.group !== undefined)
			{
				return <Optgroup key={i} name={option.name} options={option.options} />;
			}
			else
			{
				return <Option key={option.value} value={option.value} name={option.name} />;
			}
		});

		return (
			<div className="custom-select">

				<select className="field field--select" name={ this.props.name } id={ this.props.name } value={ this.props.selected } onChange={ this.handleChange }>
					{selectItems}
				</select>

			</div>
		);
	}
}

export default FilterSelect;
